import { useMediaQuery } from "@mui/material";
import { poisBountyAssets } from "assets/cdn";
import PoisBountyWidgetV3 from "components/PoisBountyWidgetV3";
import { useEnvContext } from "contexts/EnvProvider";
import { useWebStoreContext } from "contexts/WebStoreProvider";
import { FeaturesFlags } from "helpers";
import { getVariantImage } from "helpers/getVariantImage";
import { useAppSelector, useImagePath } from "hooks";
import { useEffect, useMemo, useRef, useState } from "react";
import { selectPoisBountyV3State } from "redux/slices";
import { PrivateRoute } from "routes/PrivateRoute";
import { ISectionMenuItem } from "../../components/PageTopNav";
import PageTopNavV2 from "../../components/PageTopNavV2";
import {
	Background,
	Box1,
	ClubDescription,
	Container,
	Description,
	PoisBountyWrapper,
	Title
} from "./styles";

const PoisBounty = () => {
	const { userTracker } = useWebStoreContext();
	const { isFeatureFlagEnabled } = useEnvContext();
	const isLowWidth = useMediaQuery("(max-width:719px)");
	const [bgImg, setBgImg] = useState<string | undefined>();
	const [sectionMenuData] = useState<ISectionMenuItem[]>([]);
	const { tracker, trackers } = useAppSelector(selectPoisBountyV3State);
	const { getImage } = useImagePath("cdn");
	const poisBountyRef = useRef<HTMLDivElement>(null);
	const isClub = useMemo(
		() => trackers?.eventType === "club",
		[trackers?.eventType]
	);

	const handleScrollToElement = () => {
		if (poisBountyRef.current) {
			poisBountyRef.current.scrollIntoView({
				behavior: "smooth",
				block: "end"
			});
		}
	};

	const selectBackgroundImg = () => {
		let bgImg: string = getImage(
			isLowWidth
				? poisBountyAssets.page.backgroundMobile
				: poisBountyAssets.page.background
		);
		if (isFeatureFlagEnabled(FeaturesFlags.POIS_BOUNTY_V2)) {
			if (tracker?.backgroundImageUrl) {
				bgImg = getVariantImage(
					tracker.backgroundImageUrl,
					"{pois_bounty_variant}",
					isLowWidth ? "small" : "large"
				);
			} else {
				bgImg = getImage(
					isLowWidth
						? poisBountyAssets.v2.page.defaultBackgroundMobile
						: poisBountyAssets.v2.page.defaultBackground
				);
			}
		}
		setBgImg(bgImg);
	};

	useEffect(() => {
		handleScrollToElement();
	}, []);

	useEffect(() => {
		if (tracker) {
			selectBackgroundImg();
		}
	}, [tracker, isLowWidth]);

	return (
		<PrivateRoute
			isEnabled={
				isFeatureFlagEnabled(FeaturesFlags.POIS_BOUNTY_V2) && !!userTracker
			}
		>
			<Container>
				{bgImg && <Background bgImg={bgImg} />}
				<Title src={tracker?.titleImageUrl} isClub={isClub} />
				{isClub && (
					<Description>
						{isLowWidth ? (
							<>
								This is a <span>Club event</span> - all members
								<br /> contribute and earn rewards together.
							</>
						) : (
							<>
								This is a <span>Club event</span> - all members contribute
								<br /> and earn rewards together.
							</>
						)}
					</Description>
				)}
				{isLowWidth && isClub && (
					<ClubDescription>
						<p>
							Club: <span>{trackers?.clubName}</span>
						</p>
					</ClubDescription>
				)}
				{isFeatureFlagEnabled(FeaturesFlags.UI_V2) && (
					<PageTopNavV2
						navItemColor="#FFE37E"
						sectionMenuData={sectionMenuData}
						isLandingPage
					/>
				)}
				<PoisBountyWrapper ref={poisBountyRef} isClub={isClub}>
					<Box1 className="animate__animated animate__bounceInDown">
						{isFeatureFlagEnabled(FeaturesFlags.POIS_BOUNTY_V2) && (
							<PoisBountyWidgetV3
								isPageVariant
								isPortrait={isLowWidth}
								isClub={isClub}
							/>
						)}
					</Box1>
				</PoisBountyWrapper>
			</Container>
		</PrivateRoute>
	);
};

export default PoisBounty;
